import { render, staticRenderFns } from "./TkLangBtns.vue?vue&type=template&id=c4383634&scoped=true&"
import script from "./TkLangBtns.vue?vue&type=script&lang=js&"
export * from "./TkLangBtns.vue?vue&type=script&lang=js&"
import style0 from "./TkLangBtns.vue?vue&type=style&index=0&id=c4383634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4383634",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtnToggle,VIcon,VList,VListTile,VListTileTitle,VMenu})
